import React from 'react';
import { motion } from 'framer-motion';
import { Book, Apple, ActivitySquare, Moon, FileText } from 'lucide-react';
const deliverables = [{
  icon: Book,
  title: 'Ebook Principal: Reinicio Metabólico 45+',
  desc: 'La guía completa paso a paso.'
}, {
  icon: Apple,
  title: 'El Semáforo Metabólico',
  desc: 'Lista de alimentos que sanan vs. alimentos que bloquean.'
}, {
  icon: ActivitySquare,
  title: 'Protocolo de Movimiento Inteligente',
  desc: 'Rutinas de 20 minutos que no agotan.'
}, {
  icon: Moon,
  title: 'Ritual Quema-Grasa Nocturno',
  desc: 'Cómo usar el sueño para reparar tus hormonas.'
}, {
  icon: FileText,
  title: 'Hojas de Acción y Worksheets',
  desc: 'Para rastrear tu progreso y tus señales vitales.'
}];
export function WhatYouGet() {
  return <section className="py-16 md:py-24 bg-brand-cream" data-id="element-166">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl" data-id="element-167">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-168">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-text mb-4" data-id="element-169">
            Lo que obtienes hoy
          </h2>
          <p className="text-lg text-brand-text/70" data-id="element-170">
            Todo lo que necesitas para tu reinicio metabólico en un solo lugar.
          </p>
        </motion.div>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-171">
          {deliverables.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`bg-white p-8 rounded-3xl shadow-sm border border-brand-accent/30 ${index === 0 ? 'md:col-span-2 lg:col-span-3 bg-brand-terracotta/5 border-brand-terracotta/20' : ''}`} data-id="element-172">
              <div className="w-12 h-12 bg-brand-sage/10 rounded-2xl flex items-center justify-center mb-6 text-brand-sage" data-id="element-173">
                <item.icon className="w-6 h-6" data-id="element-174" />
              </div>
              <h3 className="text-xl font-bold text-brand-text mb-2" data-id="element-175">
                {item.title}
              </h3>
              <p className="text-brand-text/70" data-id="element-176">{item.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}